export function ProjectThemeDoodle({ projectId }: { projectId: string }) {
  if (projectId === 'after-eight') {
    return (
      <svg className="project-theme-doodle" viewBox="0 0 220 120" aria-hidden="true">
        <path d="M34 105c3-43 3-73 7-91m-13 91h32M41 17c25-5 37 4 36 20-1 14-13 22-31 19" />
        <path d="M47 22c20-3 28 4 27 15-1 10-10 16-25 15M77 37c30 7 47 26 52 53" />
        <path d="M143 24c15-12 35-1 30 18-4 15-21 18-31 9 14 2 22-13 14-25" />
        <path d="M112 103c18-12 37-12 57-2 16 8 29 8 43 1" />
      </svg>
    )
  }

  if (projectId === 'unfinished') {
    return (
      <svg className="project-theme-doodle" viewBox="0 0 220 120" aria-hidden="true">
        <path d="M64 16c28-4 47 17 43 43-4 25-31 41-55 29-23-12-25-43-8-61 5-5 12-9 20-11Z" />
        <path d="M55 46c7-7 15-10 25-8m-28 27c12 8 25 7 38-2M74 91l-8 21m22-27 15 18" />
        <path d="M128 29c20-13 37 3 30 19-7 17 6 24 22 15 19-10 31 7 24 25" />
        <path d="M137 95c18-10 38-9 61 4" />
      </svg>
    )
  }

  return (
    <svg className="project-theme-doodle" viewBox="0 0 220 120" aria-hidden="true">
      <path d="M28 33 72 10l31 39-45 21-30-37Zm44-23-1 73m0 0c17 7 26 17 28 30" />
      <path d="M131 92c3-31 3-52 1-69m-17 20 17-20 18 20M120 56c9 5 17 5 25 0" />
      <path d="M158 95c12-9 24-9 36 0m-74 10c13-9 25-9 37 0m-55-8c6-5 12-5 18 0" />
      <circle cx="185" cy="31" r="14" />
      <path d="m185 8 1-8m0 62v-9m22-22h10m-65 0h10m37-17 7-7m-45 45 7-7" />
    </svg>
  )
}

export function AfterEightSideArt() {
  return (
    <aside className="project-side-art" role="img" aria-label="晚八点主题手绘夜行路线、路灯与气味轨迹装饰">
      <div className="side-art-label">NIGHT WALK NOTES</div>
      <svg className="night-walk-drawing" viewBox="0 0 360 520" aria-hidden="true">
        <path className="doodle-bold" d="M72 478c2-131 5-262 10-393m-29 393h66M83 87c56-13 83 9 78 48-5 34-35 50-72 40" />
        <path d="M91 99c43-8 61 7 57 35-4 23-25 35-55 29" />
        <path className="lamp-glow" d="M142 132c72 29 104 83 97 162" />
        <path d="M18 480c51-27 96-27 136 0 44 29 92 27 146-7" />
        <path d="M183 417c17-18 34-18 50 0m-85 29c15-15 30-15 45 0m67-55c10-10 21-10 32 0" />
        <path className="doodle-accent" d="M252 80c21-19 51-3 44 25-5 20-29 27-44 13 21 2 32-21 19-37" />
        <path d="M278 152h45v118h-45zm-52 38h52v80h-52m64-72h11m-11 28h11m-60-12h14m-14 25h14" />
        <path className="doodle-dash" d="M173 358c-33-10-55-2-67 25-9 22 1 37 29 46" />
        <circle cx="105" cy="386" r="5" />
        <circle cx="126" cy="425" r="5" />
      </svg>

      <div className="side-art-timeline">
        <span><b>19:30</b> 关掉最后一条工作消息</span>
        <span><b>20:00</b> 城市灯箱亮起</span>
        <span><b>20:30</b> 到店试闻与留言</span>
        <span><b>21:00</b> 带一张晚安试香纸回家</span>
      </div>

      <svg className="scent-route-drawing" viewBox="0 0 360 430" aria-hidden="true">
        <path className="doodle-accent" d="M38 94c76-62 129 30 87 77-37 42 17 89 68 45 58-49 101-7 118 37" />
        <path className="doodle-dash" d="M47 113c64-46 103 20 70 58m92 38c42-26 76-10 100 47" />
        <path className="doodle-bold" d="M128 397h106l-9-139h-88l-9 139Zm24-176h58v37h-58zm12-35h35v35h-35" />
        <path d="M154 309c17-17 35-17 54 0-18 18-36 18-54 0Z" />
        <path d="m48 298 8 18 20 3-15 13 4 20-17-10-17 10 4-20-15-13 20-3 8-18Z" />
        <path d="M276 337c14-22 28-22 43 0-15 20-29 20-43 0Z" />
        <text x="140" y="420">SCENT = SWITCH</text>
      </svg>
    </aside>
  )
}

function UnfinishedSideArt() {
  return (
    <aside className="project-side-art project-side-art--skin" role="img" aria-label="未满主题手绘镜子、七天试用记录与护肤软管装饰">
      <div className="side-art-label">NO-SCORE SKIN NOTES</div>
      <svg className="night-walk-drawing" viewBox="0 0 360 520" aria-hidden="true">
        <path className="doodle-bold" d="M180 53c88 0 137 68 124 151-13 80-85 131-163 110-74-20-108-104-68-173 23-39 59-84 107-88Z" />
        <path d="M126 157c16-14 34-16 53-6m42 3c16-10 32-8 48 6M149 239c27 18 55 17 84-2" />
        <path className="doodle-accent" d="M103 113c-22 45-20 92 7 141m139-154c29 34 37 75 23 122" />
        <path d="M164 320c-6 56-19 94-39 115m70-115c15 51 37 87 66 107M96 438c54-25 111-24 171 3" />
        <path className="doodle-dash" d="M54 76c21-34 46-52 75-55m140 38c26 18 42 42 49 72" />
        <text x="103" y="486">SKIN IS NOT A SCORE</text>
      </svg>
      <div className="side-art-timeline">
        <span><b>DAY 1</b> 记录步骤是否简单</span>
        <span><b>DAY 3</b> 记录肤感与使用负担</span>
        <span><b>DAY 5</b> 记录皮肤是否打扰生活</span>
        <span><b>DAY 7</b> 不打分，只写下一句感受</span>
      </div>
      <svg className="scent-route-drawing" viewBox="0 0 360 430" aria-hidden="true">
        <path className="doodle-bold" d="M67 371 89 92h91l19 279H67Zm31-321h72v42H98m126 279 17-218h70l13 218H224Zm28-253h47v35h-47" />
        <path className="doodle-accent" d="M106 175c23-19 45-19 67 1m73 78c21-16 42-15 63 3" />
        <path d="M117 232c13 12 27 12 41 0m97 76c14 11 28 11 42 0" />
        <path className="doodle-dash" d="M20 55c77 38 155 31 234-20 35-23 65-18 89 14" />
        <text x="72" y="411">LESS STEPS, CLEAR PROOF</text>
      </svg>
    </aside>
  )
}

function WeekendSideArt() {
  return (
    <aside className="project-side-art project-side-art--weekend" role="img" aria-label="无用周末节主题手绘公园地图、现场时间轴和风筝帐篷装饰">
      <div className="side-art-label">FIELD PLAN, SLOW DAY</div>
      <svg className="night-walk-drawing" viewBox="0 0 360 520" aria-hidden="true">
        <path className="doodle-bold" d="M37 435c45-61 94-78 147-52 47 23 91 17 133-17M68 386V166m-42 79c14-41 28-67 42-79 17 13 34 40 51 79-31-13-62-13-93 0Z" />
        <path d="M210 405V254m-38 52c12-29 25-47 38-52 15 6 30 25 46 57-29-11-57-13-84-5Z" />
        <path className="doodle-accent" d="m255 51 58 42-48 53-56-45 46-50Zm0 0 4 96m0 0c-33 32-38 70-15 114" />
        <path className="doodle-dash" d="M23 454c60 29 119 29 178 0 49-24 96-22 140 6" />
        <path d="M116 325h62v54h-62zm9-16h44v16m-31-67c22-15 43-15 64 0" />
        <text x="69" y="493">DON'T RUSH THE GRASS</text>
      </svg>
      <div className="side-art-timeline">
        <span><b>13:00</b> 分时核销与手机寄存</span>
        <span><b>14:00</b> 没结果工作坊开放</span>
        <span><b>16:00</b> 随机节目与品牌补给</span>
        <span><b>18:00</b> 物资清点与现场复盘</span>
      </div>
      <svg className="scent-route-drawing" viewBox="0 0 360 430" aria-hidden="true">
        <path className="doodle-bold" d="M47 347 177 119l137 228H47Zm130-228v228M84 285h190" />
        <path className="doodle-accent" d="M59 87c53-58 107-61 162-8 36 34 72 36 108 7" />
        <path d="M38 371c37-19 72-19 106 0 32 18 65 18 99 0 30-17 60-16 90 2" />
        <path className="doodle-dash" d="M27 63c26-15 49-15 70 1m144 22c25-13 48-12 69 4" />
        <circle cx="48" cy="159" r="23" />
        <path d="M48 123v-17m0 89v-15m36-21h17m-106 0h17" />
        <text x="78" y="411">FRONT STAGE SLOW / BACK STAGE CLEAR</text>
      </svg>
    </aside>
  )
}

export function ProjectSideArt({ projectId }: { projectId: string }) {
  if (projectId === 'after-eight') return <AfterEightSideArt />
  if (projectId === 'unfinished') return <UnfinishedSideArt />
  return <WeekendSideArt />
}
